export default "__VITE_ASSET__gC_iCwV5__"